
import "./CreateClient.css";
import React, { Dispatch } from "react";
import ClearIcon from '@mui/icons-material/Clear';

type propsData = {
    profilePicture: File[] | null,
    companyLogo: File[] | null,
    personalLogo: File[] | null,
    additionalImages: File[] | null,
    showProfilePicture: string[] | null,
    showPersonalLogo : string[] | null,
    showCompanyLogo : string[] | null,
    showAdditionalImage: string[] | null,
    setProfilePicture: Dispatch<React.SetStateAction<File[]>>,
    setPersonalLogo: Dispatch<React.SetStateAction<File[]>>,
    setCompanyLogo: Dispatch<React.SetStateAction<File[]>>,
    setAdditionalImages: Dispatch<React.SetStateAction<File[]>>,
    setShowProfilePicture:  Dispatch<React.SetStateAction<any[]>>,
    setShowPersonalLogo: Dispatch<React.SetStateAction<any[]>>,
    setShowCompanyLogo: Dispatch<React.SetStateAction<any[]>>,
    setShowAdditionalImage: Dispatch<React.SetStateAction<any[]>>,
}

function AddClientImages(props: propsData) {

    const {
        profilePicture,
        companyLogo,
        personalLogo,
        additionalImages,
        showProfilePicture,
        showPersonalLogo,
        showCompanyLogo,
        showAdditionalImage,
        setProfilePicture,
        setPersonalLogo,
        setCompanyLogo,
        setAdditionalImages,
        setShowProfilePicture,
        setShowPersonalLogo,
        setShowCompanyLogo,
        setShowAdditionalImage
    } = props

    const profilePicHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowProfilePicture((showProfilePicture: any[]) => {
                    return [ ...showProfilePicture, reader.result ];
                })
            }
        }
        if (files) {
            setProfilePicture((profilePicture: File[]) => {
                return [ ...profilePicture, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const personalLogoHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowPersonalLogo((showPersonalLogo: any[]) => {
                    return [ ...showPersonalLogo, reader.result ];
                })
            }
        }

        if (files) {
            setPersonalLogo((personalLogo: File[]) => {
                return [ ...personalLogo, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const companyLogoHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowCompanyLogo((showCompanyLogo: any[]) => {
                    return [ ...showCompanyLogo, reader.result ];
                })
            }
        }
        if (files) {
            setCompanyLogo((companyLogo: File[]) => {
                return [ ...companyLogo, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const additionalFotoHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const files = e.target.files;
        let reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                setShowAdditionalImage((showAdditionalImage: any[]) => {
                    return [ ...showAdditionalImage, reader.result ];
                })
            }
        }
        if (files) {
            setAdditionalImages((additionalImages: File[]) => {
                return [ ...additionalImages, files[0] ];
            })
            reader.readAsDataURL(files[0]);
        }
    }

    const deleteProfilePicture = (ind: number) => {
        setProfilePicture((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowProfilePicture((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
    }

    const deletePersonalLogo = (ind: number) => {
        setPersonalLogo((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowPersonalLogo((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
    }

    const deleteCompanyLogo = (ind: number) => {
        setCompanyLogo((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowCompanyLogo((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
    }

    const deleteAdditionalImage= (ind: number) => {
        setAdditionalImages((profilePicture: File[]) => profilePicture.filter((item: File, index: number) => index !== ind));
        setShowAdditionalImage((showProfilePicture: any[]) => showProfilePicture.filter((item: any, index: number) => index !== ind));
    }

    return (
        <div className="AddClientImages">
            <div className="addClientImagesHead">
                <span>Profile Pictures</span>
                <span>Personal Logos</span>
                <span>Company Logos</span>
                <span>Additional Images </span>
            </div>
            <div className="allImagesBox">
                <div className="addClientPictureBox">
                    {
                        showProfilePicture!.map((picture: any, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Profile Picture</span>
                                        <span className="addFileBtn">
                                            <input
                                                type="file"
                                                className="addFileInput"
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img
                                            className = "addNewImage"
                                            src = { picture }
                                            alt = { "image" }
                                        />
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                        { profilePicture![index].name }
                                    </span>
                                    <ClearIcon
                                        style = {{
                                            color: "#999",
                                            cursor: "pointer",
                                        }}
                                        onClick = { () => deleteProfilePicture(index) }
                                    />
                                </div>
                            </div>
                        })
                    }
                    {
                        showProfilePicture!.length < 3 &&
                            <div className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ showProfilePicture!.length + 1 } Profile Picture </span>
                                        <span className="addFileBtn">
                                            <input
                                                type = "file"
                                                className = "addFileInput"
                                                onChange = { (e) => profilePicHandler(e) }
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                    </div>
                                </div>
                            </div>
                    }
                </div>
                <div className="addClientPictureBox">
                    {
                        showPersonalLogo!.map((picture: string, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                        <div className="concretImageBox" key = { index } >
                                            <div className="concretImageButtonAndFotoBox">
                                                <span>{ index + 1 } Personal Logo</span>
                                                <span className="addFileBtn">
                                                    <input
                                                        type="file"
                                                        className="addFileInput"
                                                    />
                                                    Choose File
                                                </span>
                                            </div>
                                            <div className="concretImageNameBox">
                                                <img className="addNewImage" src = { picture } alt = { "image" }/>
                                            </div>
                                        </div>
                                        <div className="newImageNameAndDeleteBox">
                                            <span
                                                style = {{
                                                    color: "#999",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: "85%",
                                                    display: "inline-block",
                                                }}
                                            >
                                                { personalLogo![index].name }
                                            </span>
                                            <ClearIcon
                                                style = {{
                                                    color: "#999",
                                                    cursor: "pointer",
                                                }}
                                                onClick = { () => deletePersonalLogo(index) }
                                            />
                                        </div>
                                    </div>
                        })
                    }
                    {
                        showPersonalLogo!.length < 3 &&
                            <div className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ showPersonalLogo!.length + 1 } Personal Logo </span>
                                        <span className="addFileBtn">
                                            <input
                                                type = "file"
                                                className = "addFileInput"
                                                onChange = { personalLogoHandler }
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">

                                    </div>
                                </div>
                            </div>
                    }
                </div>
                <div className="addClientPictureBox">
                    {
                        showCompanyLogo!.map((picture: string, index: number) => {
                            return <div key = { index } className = "addimageExampleBox">
                                <div className="concretImageBox" key = { index }>
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Company Logo</span>
                                        <span className = "addFileBtn">
                                            <input type = "file" className="addFileInput"/>
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img className="addNewImage" src = { picture } alt = { "image" }/>
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                        { companyLogo![index].name }
                                    </span>
                                    <ClearIcon
                                        style = {{
                                            color: "#999",
                                            cursor: "pointer",
                                        }}
                                        onClick = { () => deleteCompanyLogo(index) }
                                    />
                                </div>
                            </div>
                            }
                        )
                    }
                    {
                        showCompanyLogo!.length < 3 &&
                            <div className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ showCompanyLogo!.length + 1 } Company Logo</span>
                                        <span className="addFileBtn">
                                            <input type = "file" className="addFileInput" onChange = { companyLogoHandler }/>
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">

                                    </div>
                                </div>
                            </div>
                    }
                </div>
                <div className="addClientPictureBox">
                    {
                        showAdditionalImage!.map((picture: string, index: number) => {
                            return <div key = { index } className="addimageExampleBox">
                                <div className="concretImageBox" key = { index }>
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ index + 1 } Additional Image</span>
                                        <span className="addFileBtn">
                                            <input type = "file" className="addFileInput"/>
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">
                                        <img className="addNewImage" src = { picture } alt = "image"/>
                                    </div>
                                </div>
                                <div className="newImageNameAndDeleteBox">
                                    <span
                                        style = {{
                                            color: "#999",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            maxWidth: "85%",
                                            display: "inline-block",
                                        }}
                                    >
                                        { additionalImages![index].name }
                                    </span>
                                    <ClearIcon
                                        style = {{
                                            color: "#999",
                                            cursor: "pointer",
                                        }}
                                        onClick = { () => deleteAdditionalImage(index) }
                                    />
                                </div>
                            </div>
                        })
                    }
                    {
                        showAdditionalImage!.length < 3 &&
                            <div className="addimageExampleBox">
                                <div className="concretImageBox">
                                    <div className="concretImageButtonAndFotoBox">
                                        <span>{ showAdditionalImage!.length + 1 } Additional Image</span>
                                        <span className="addFileBtn">
                                            <input
                                                type = "file"
                                                className = "addFileInput"
                                                onChange = { additionalFotoHandler }
                                            />
                                            Choose File
                                        </span>
                                    </div>
                                    <div className="concretImageNameBox">

                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default AddClientImages
